import { motion } from "framer-motion";
import { Compass, Code2, Rocket } from "lucide-react";

const steps = [
  {
    n: "01",
    icon: Compass,
    title: "Planung",
    desc: "Wir hören zu, verstehen Ihr Geschäft und definieren Ziele, Zielgruppe und Inhalte. Daraus entsteht ein klares Konzept und ein Wireframe.",
    points: ["Strategie-Call", "Wireframes", "Inhalts­struktur"],
  },
  {
    n: "02",
    icon: Code2,
    title: "Umsetzung",
    desc: "Design und Entwicklung gehen Hand in Hand. Sie sehen Fortschritt früh, geben Feedback und erleben Ihr Projekt entstehen.",
    points: ["UI Design", "Frontend Entwicklung", "Iteration"],
  },
  {
    n: "03",
    icon: Rocket,
    title: "Livegang",
    desc: "Wir kümmern uns um Hosting, SEO-Grundlagen und einen sauberen Launch. Danach bleiben wir an Ihrer Seite — auch nach dem Go-Live.",
    points: ["QA & Testing", "SEO-Setup", "Launch & Support"],
  },
];

export default function Process() {
  return (
    <section
      id="prozess"
      data-testid="process-section"
      className="relative py-24 sm:py-32 border-t border-white/[0.05]"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="max-w-3xl">
          <span className="text-[11px] uppercase tracking-[0.22em] text-zinc-500 font-semibold">
            ↳ Prozess
          </span>
          <h2 className="mt-3 font-display text-3xl sm:text-5xl text-white tracking-tight leading-[1.05]">
            In drei Schritten zur fertigen Website.
          </h2>
          <p className="mt-5 text-zinc-400 leading-relaxed">
            Strukturiert, transparent und ohne Bauchgefühl-Überraschungen.
          </p>
        </div>

        <div className="mt-20 relative">
          {/* Connecting line */}
          <div className="hidden md:block absolute left-0 right-0 top-[42px] h-px bg-gradient-to-r from-transparent via-white/[0.12] to-transparent" />

          <div className="grid md:grid-cols-3 gap-10 md:gap-6">
            {steps.map((s, i) => {
              const Icon = s.icon;
              return (
                <motion.div
                  key={s.n}
                  initial={{ opacity: 0, y: 24 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true, margin: "-80px" }}
                  transition={{ duration: 0.7, delay: i * 0.12, ease: [0.16, 1, 0.3, 1] }}
                  data-testid={`process-step-${i}`}
                  className="relative"
                >
                  <div className="relative w-[84px] h-[84px] rounded-2xl bg-[#0a0a0b] border border-white/[0.08] flex items-center justify-center">
                    <Icon className="w-6 h-6 text-white" />
                    <span className="absolute inset-0 rounded-2xl bg-blue-500/0 group-hover:bg-blue-500/[0.04] transition-colors" />
                    <span className="absolute -bottom-3 -right-3 w-9 h-9 rounded-full bg-[#050505] border border-white/10 flex items-center justify-center font-mono text-[11px] text-zinc-400">
                      {s.n}
                    </span>
                  </div>

                  <h3 className="mt-7 font-display text-xl text-white tracking-tight">
                    {s.title}
                  </h3>
                  <p className="mt-3 text-sm text-zinc-400 leading-relaxed max-w-sm">
                    {s.desc}
                  </p>
                  <ul className="mt-5 space-y-1.5">
                    {s.points.map((p) => (
                      <li
                        key={p}
                        className="flex items-center gap-2 text-[13px] text-zinc-500"
                      >
                        <span className="w-1 h-1 rounded-full bg-blue-400/70" />
                        {p}
                      </li>
                    ))}
                  </ul>
                </motion.div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}
